import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (
                AuthService.isUserPhysician() ||
                AuthService.isActiveMemberPhysician() ||
                AuthService.isPracticeAncillary() ||
                AuthService.isUserPracticeOther() ||
                AuthService.isUserTemporaryPhysician()
            ) {
                return next()
            } else if (AuthService.getUser().isMasterUser) {
                next({ name: 'practice.members' })
            }

            next({ name: 'auth.select-physician' })
        })
    },
}
